export default "__VITE_ASSET__CweYMHIJ__"